<template>
    <Modal :id="'Ligacao_Crud'" :size="''" :open="show" :FooterDefault="false">
        <template v-slot:header>
            <h6 class="modal-title">Ligar</h6>
            <button type="button" class="btn" data-bs-dismiss="modal" aria-label="Close" @click="fecharModal()">
                <i class="fas fa-times btn-close-style"></i>
            </button>
        </template>
        <template v-slot:body>
            <div class="row">
                <!-- ESQUERDA -->
                <div class="col" style="min-height: calc(100vh - 8rem); max-height: calc(100vh - 8rem); overflow:auto;">
                    <div class="d-flex mb-2">
                        <button class="btn-red col" @click="func_crud(pessoa.idPessoa, 'Mapa')" v-if="idInstituicao > 0">
                            <i class="fa fa-duotone fa-map" aria-hidden="true"></i>
                            <span class="btn-span-text">Ver mapa de clientes</span>
                        </button>
                        <button class="btn-red col" @click="gera_historico_comercial" style="margin-left: 20px;" v-if="idInstituicao > 0">
                            <i class="fas fa-history"></i>
                            <span class="btn-span-text">Histórico Comercial</span>
                        </button>
                        <button class="btn-red col" @click="enviarEmail(pessoa.dsEmail)" style="margin-left: 20px;">
                            <i class="fa fa-solid fa-envelope"></i><span class="btn-span-text">Enviar e-mail</span>
                        </button>
                    </div>
                    <div class="card_registro d-flex mb-2 mt-2" v-if="idInstituicao > 0">
                        <div class="solid_bar"></div>
                        <div class="col">
                            <div class="d-flex">
                                <div class="col">
                                    <h3>Empresa</h3>
                                    <span class="card_text"># {{ dados.cdInstituicao }} {{ dados.nmRazaoSocial }}</span>
                                    <span class="float-end me-3">
                                        <i v-for="index in 6" :key="index" :class="index <= dados.nrNotaCliente ? 'fas fa-star' : 'far fa-star'" class="star-avaliacao"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card_registro d-flex mb-2 mt-2">
                        <div class="solid_bar"></div>
                        <div class="col">
                            <div class="d-flex">
                                <div class="col">
                                    <h3>Nome</h3>
                                    <span class="card_text">{{ pessoa.nmPessoa }}</span>
                                </div>
                            </div>
                            <div class="d-flex mb-2 mt-2">
                                <div class="col">
                                    <h3>Departamento</h3>
                                    <span class="card_text">{{ pessoa.nmDepartamento }}</span>
                                </div>
                                <div class="col">
                                    <h3>Função</h3>
                                    <span class="card_text">{{ pessoa.nmFuncao }}</span>
                                </div>
                            </div>
                            <div class="d-flex mb-2 mt-2">
                                <div class="col-6">
                                    <h3>E-mail</h3>
                                    <span class="card_text">{{ pessoa.dsEmail }}</span>
                                </div>
                                <div class="col">
                                    <h3>Celular</h3>
                                    <span class="card_text">{{ pessoa.nrCelular }}</span>
                                </div>
                                <div class="col">
                                    <h3>Telefone</h3>
                                    <span class="card_text">{{ pessoa.nrTelefone }}</span>
                                </div>
                            </div>
                        </div>
                        <div>
                            <button class="btn btn-secondary" @click="func_crud(pessoa.idPessoa, 'Alterar')">
                                <i class="fas fa-pencil-alt" aria-hidden="true"></i> Editar contato
                            </button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col" v-if="idPessoa != 0 && ligar_crud.nrUniqueId == ''">
                            <div class="table-dados">
                                <DataTable :url_ajax="getPessoaTelefone()" :ajax_set_result="setHistorico"
                                           @grid_refreshed="gridRefreshed" :refresh="refresh_grid" :filtros="filtro" method="GET"
                                           :qtd_registros_por_pagina="8" :is_table="true" :footer_fixed="true"
                                           :headers="headersTelefone" :pBtnsSlot="true" :request_api="'comercial'">
                                    <template v-slot:BtnSlot="item">
                                        <div class="campo">
                                            <div class="d-flex">
                                                <div class="d-flex">
                                                    <input class="form-check-input checkbox-out" type="radio" name="action"
                                                           :id="item.row.nrTelefone"
                                                           @click="selecionarTelefone(item.row.nrTelefone)" />
                                                    <h3 style="margin-top: 4px; margin-left: 8px;">
                                                        {{ item.row.nrTelefone }}
                                                    </h3>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </DataTable>
                            </div>
                            <div v-if="status == 0" class="mt-2 col" style="padding-right:10px; padding-left:10px;">
                                <div class="row">
                                    <label class="form-label">Linhas de saída</label>
                                    <vue-select v-model="linhaSaidaSelects" :options="linhaSaidaOptions"
                                                :label-by="(e) => (e.nmLinha)" placeholder="Selecione o tipo de Linha"
                                                search-placeholder="Pesquise" searchable close-on-select clear-on-select :min="1"
                                                class="form-control shadow-v2">
                                    </vue-select>
                                </div>
                                <div class="mb-2 mt-2 row">
                                    <label class="form-label">Número</label>
                                    <Field name="nrTelefone" type="text" class="form-control shadow-v2" rules="required"
                                           placeholder="Digite ou selecione um número para ligar" v-model="telefone"
                                           :class="{ filled: telefone }" />
                                </div>
                                <div class="d-flex mt-3 mb-2 row">
                                    <button class="btn-red col" @click="ligacao(telefone)" :disabled="telefone == ''">
                                        <i class="fas fa-phone" aria-hidden="true"></i><span class="btn-span-text">
                                            Ligar
                                        </span>
                                    </button>
                                </div>
                            </div>
                            <div class="d-flex align-items-center flex-column justify-content-center" v-if="status == 1">
                                <div class="spinner-border text-danger" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                                <span class="card_text mt-2">Aguardando complemento de Ligação ...</span>
                            </div>
                        </div>
                        <div class="col" v-if="ligar_crud.nrUniqueId != ''">
                            <div class="mt-2">
                                <label class="form-label">Anotação:</label>
                                <ckeditor :editor="editor" v-model="ligar_crud.dsAnotacao"></ckeditor>
                            </div>

                            <div class="row mb-3 mt-4 check-box">
                                <div class="d-flex">

                                    <select class="form-select shadow-v2 text-muted" v-model="ligacao_texto_padrao" style="max-width: 380px; margin-right:15px;">
                                        <option selected value="">Selecione</option>
                                        <option v-for="tipo_padrao in tipos_ligacao_textos_padroes" :key="tipo_padrao.idLigacaoTextoPadrao" :value="tipo_padrao.nmLigacaoTextoPadrao">
                                            {{ tipo_padrao.nmLigacaoTextoPadrao }}
                                        </option>
                                    </select>

                                    <div style="margin-top:5px;">
                                        <input class="form-check-input checkbox-out" type="checkbox" id="checkbox1" v-model="ligar_crud.flEfetiva" />
                                        <label for="checkbox1">
                                            <strong>Efetiva</strong>
                                        </label>
                                    </div>

                                    <div style="margin-top:5px; margin-left:5px;">
                                        <input class="form-check-input checkbox-out" type="checkbox" id="checkbox2" v-model="ligar_crud.flImportante" />
                                        <label for="checkbox2">
                                            <strong>Importante</strong>
                                        </label>
                                    </div>

                                    <div class="ms-auto"><Microphone @refresh_anotacao="refresh_anotacao" /></div>
                                </div>
                            </div>

                            <div class="d-flex flex-wrap mb-3 mt-4">

                                <button type="button" class="btn btn-outline-dark" v-on:click="abreModalInfo(1)">
                                    <i class="fa fa-newspaper"></i> Dados do Ticket
                                </button>

                                <button type="button" class="btn btn-outline-dark ms-1" v-on:click="abreModalInfo(2)">
                                    <i class="far fa-check-square"></i> Tarefas Executar
                                </button>

                                <button type="button" class="btn btn-outline-dark ms-1" v-on:click="abreModalInfo(3)">
                                    <i class="far fa-calendar-alt"></i> Agendamentos
                                </button>

                                <button type="button" class="btn btn-outline-dark ms-1" v-on:click="abreModalInfo(10)" v-if="(dados.idContrato <= 0 || dados.idContrato == null) && (dados.idEvento <= 0 || dados.idEvento == null)">
                                    <i class="fas fa-address-card"></i> Senhas
                                </button>

                                <button type="button" class="btn btn-outline-dark ms-1" v-on:click="abreModalInfo(8)">
                                    <i class="fas fa-money-bill-alt "></i> Proposta
                                </button>

                                <button type="button" class="btn btn-outline-dark ms-1" v-on:click="abreModalInfo(9)">
                                    <i class="far fa-file-alt"></i> Processo
                                </button>

                                <button type="button" class="btn btn-outline-dark ms-1" v-on:click="abreModalInfo(10)" v-if="dados.idContrato > 0">
                                    <i class="fas fa-user-friends"></i> Usuários
                                </button>

                            </div>

                            <div class="d-flex mb-3 mt-4">

                                <div class="ms-auto">
                                    <span style="margin-right:15px; font-weight:bold; font-size:12px;">Número: {{ telefone }}</span>
                                    <button type="button" class="btn btn-warning " v-on:click="rediscar_numero()">
                                        <i class="fas fa-retweet"></i> Rediscar
                                    </button>
                                </div>

                                <button class="btn btn-danger btn-gnp ms-3" @click="adicionar(false)" :disabled="ligar_crud.dsAnotacao == ''">
                                    <i class="fas fa-save"></i> Incluir anotação
                                </button>
                            </div>

                        </div>
                    </div>
                </div>


                <!-- DIREITA -->
                <div class="col">
                    <div class="d-flex g-6 mb-2 ">
                        <div class="col card_contato" style="left: -11px;">
                            <h3 class="text-center">Data do último contato</h3>
                            <span>{{ ultimaLigacao.dtInclusao }}</span>
                        </div>
                        <div class="col card_contato" style="margin-right: 10px; right: -11px;">
                            <h3 class="text-center">Último consultor do contato</h3>
                            <span>{{ ultimaLigacao.dsLogin }}</span>
                        </div>
                        <button class="btn btn-danger btn-gnp btn-div ms-2" @mouseover="mostraDiv"><i class="fas fa-angle-double-left"></i></button>
                    </div>
                    <RegistrosGrid :id="'registros_ligacao'" :idOcorrencia="idOcorrencia" :idPessoa="0"
                                   :reloadGrid="nrReloadGrid" :filtroBusca="filtroBusca"
                                   :customHeightRegGrid="'max-height: calc(100vh - 18rem);min-height: calc(100vh - 18rem);'"
                                   :customHeightRegGridNoPage="dinamicTableRegNoPage"
                                   :customSizeWid="'width:103%;left:0;'" />
                    <transition name="slide">
                        <div v-if="mostraTransicao" @mouseout="escondeDiv" class="container-fluid box-overlay">
                            <div class="d-flex fundo-panel">
                                <div class="flex-grow-1">
                                    <InputSearch v-model="filtro_text" placeholder="Pesquisar por Nº Unidade de Compra, Nome Unidade de Compra, ou CNPJ..." @updateSearch="reloadGrid" @keypress.enter="reloadGrid" />
                                </div>
                            </div>
                            <div class="table-dados" style="padding-right: 7px; padding-left: 7px;">
                                <DataTable :url_ajax="getUrlTodosContatos()"
                                           :customHeightPaginate="'max-height: calc(100vh - 17.8rem); min-height: calc(100vh - 17.8rem);'"
                                           :customHeight="'max-height: calc(100vh - 14.5rem); min-height: calc(100vh - 14.5rem);'"
                                           :ajax_set_result="setHistorico" @grid_refreshed="gridRefreshed" :refresh="refresh_grid"
                                           :filtros="filtro" method="GET" :qtd_registros_por_pagina="8" :is_table="true" :footer_fixed="false"
                                           :headers="headersTodosContatos" :pBtnsSlot="true" :is_NotLoading="NotLoading" :is_modal="true"
                                           sizeWidBooton="width:102%;" :request_api="'comercial'">
                                    <template v-slot:BtnSlot="item">
                                        <div class="campo">
                                            <div class="d-flex mb-1">
                                                <div class="col-6" v-on:click="historicoPessoa(item.row.idPessoa)">
                                                    <h3 class="mb-0">Nome</h3>
                                                    <span class="data text-break" style="text-align: left;">{{ item.row.nmPessoa }}</span>
                                                </div>
                                                <div class="col-3">
                                                    <h3 class="mb-0">Departamento</h3>
                                                    <span class="data ">{{ item.row.nmDepartamento }}</span>
                                                </div>
                                                <div class="col-3">
                                                    <button type="button" class="btn-grid-editar-lista btn-Ligar"
                                                            @click="ligar(item.row.idPessoa)" style="margin-right:11px;min-width: 42.5%;max-width: 42.5%;">
                                                        <i class="fas fa-phone" aria-hidden="true"></i><span class="btn-span-text">Ligar</span>
                                                    </button>
                                                </div>
                                            </div>
                                            <div class="d-flex">
                                                <div class="col">
                                                    <h3 class="mb-0">E-Mail</h3>
                                                    <span class="data">{{ item.row.dsEmail }}</span>
                                                </div>
                                                
                                            </div>
                                        </div>
                                    </template>
                                </DataTable>
                            </div>
                        </div>
                    </transition>
                </div>



            </div>
        </template>

        <template v-slot:footer>
            <div class="modal-footer">
                <button type="button" class="btn btn-close-clean-v2 mt-2" data-bs-dismiss="modal" @click="fecharModal()">
                    Fechar
                </button>
            </div>
        </template>

    </Modal>

    <modal-warper v-if="emailStart > 0" target="Enviar_Email" :show="isOpenModalEnviarEmail" @close="(isOpenModalEnviarEmail = false, emailStart = 0)">
        <EnviarEmail :idOcorrencia="idOcorrencia" :idPessoa="idPessoa" :show="isOpenModalEnviarEmail" :idInstituicao="idInstituicao" :idModulo="idModulo" :nmPessoa="pessoa.nmPessoa" :nmEmpresa="nmEmpresa" :nrTelefone="telefone" @reloadGrid="reloadGrid" />
    </modal-warper>

    <modal-warper v-if="mapaStart > 0" target="Mapa_Clientes" :show="isOpenModalMapa"
                  @close="(isOpenModalMapa = false, mapaStart = 0)">
        <MapaCliente :idOcorrencia="idOcorrencia" :nrMetros="100000" :show="isOpenModalMapa" :idInstituicao="idInstituicao" :idModulo="idModulo" />
    </modal-warper>

    <modal-warper v-if="contatoStart > 0" target="ContatoCrudLigacao" :show="isOpenModalConatoCrudEm"
                  @close="(isOpenModalConatoCrudEm = false, contatoStart = 0)">
        <ContatoCrud :key="key_modal_crud" :idOcorrencia="idOcorrencia" :idPessoa="idPessoa"
                     modalContatoId="ContatoCrudLigacao" :show="isOpenModalConatoCrudEm" :idInstituicao="idInstituicao"
                     @getDadosOcorrenciaLigacao="getPessoa" />
    </modal-warper>


    <modal-warper target="ModalTicketInfo" :show="isOpenModalTicketInfo" @close="(isOpenModalTicketInfo = false)">
        <Modal id="ModalTicketInfo" :open="isOpenModalTicketInfo" :FooterDefault="false" :ClassBG="true" :customModalBody="'padding-top:0;'">
            <template v-slot:header>
                <h6 class="modal-title"></h6>
                <button type="button" class="btn" data-bs-dismiss="modal" aria-label="Close" @click="fecharModalInfo()">
                    <i class="fas fa-times btn-close-style-v2 hover-effect"></i>
                </button>
            </template>

            <template v-slot:body>
                <div class="mt-3 content-modal-info">
                    <Dados :idOcorrencia="idOcorrencia" v-if="cdModalInfo == 1"></Dados>
                    <Tarefas_Executar :idOcorrencia="idOcorrencia" v-else-if="cdModalInfo == 2"></Tarefas_Executar>
                    <Agendamento :idOcorrencia="idOcorrencia" v-else-if="cdModalInfo == 3"></Agendamento>
                    <Senhas :idModulo="idModulo" :idOcorrencia="idOcorrencia" v-if="cdModalInfo == 10 && (dados.idContrato <= 0 || dados.idContrato == null) && (dados.idEvento <= 0 || dados.idEvento == null)"></Senhas>
                    <PropostaEventos :idOcorrencia="idOcorrencia" v-else-if="cdModalInfo == 8 && dados.idEvento > 0"></PropostaEventos>
                    <Proposta :idOcorrencia="idOcorrencia" v-else-if="cdModalInfo == 8"></Proposta>
                    <Processo :idOcorrencia="idOcorrencia" v-else-if="cdModalInfo == 9"></Processo>
                    <Usuarios :idOcorrencia="idOcorrencia" :flContato="true" v-else-if="cdModalInfo == 10"></Usuarios>
                </div>
            </template>

            <template v-slot:footer>
                <div class="modal-footer">
                    <button type="button" class="btn btn-close-clean-v2 mt-2" data-bs-dismiss="modal" @click="fecharModalInfo()">
                        Fechar
                    </button>
                </div>
            </template>
        </Modal>

    </modal-warper>


</template>

<script>

    import axios from 'axios';
    import Modal from '@/components/App/Modal.vue';
    import DataTable from '@/components/App/Datatable.vue';
    import ModalWarper from '@/components/App/ModalWarper.vue'
    import EnviarEmail from './EnviarEmail.vue';
    import ContatoCrud from '@/views/Modais/InstituicaoPessoas/PessoaCrud.vue'
    import MapaCliente from './MapaClientes.vue';
    import RegistrosGrid from '@/views/Modais/Ocorrencia/Grids/Registros_Grid.vue';
    import VueNextSelect from 'vue-next-select'
    import InputSearch from '@/components/App/Input_Search.vue';
    import 'vue-next-select/dist/index.min.css'
    import Microphone from '@/components/App/Microphone.vue';
    import CryptoJS from 'crypto-js';

    import Dados from '@/views/Modais/Ocorrencia/Tabs/Dados.vue'
    import Tarefas_Executar from '@/views/Modais/Ocorrencia/Tabs/Tarefas_Executar.vue'
    import Agendamento from '@/views/Modais/Ocorrencia/Tabs/Agendamento.vue'
    import Senhas from '@/views/Modais/Ocorrencia/Tabs/Cortesia.vue'
    import Proposta from '@/views/Modais/Ocorrencia/Tabs/Proposta.vue'
    import PropostaEventos from '@/views/Modais/Ocorrencia/Tabs/PropostaEventos.vue'
    import Processo from '@/views/Modais/Ocorrencia/Tabs/Processo.vue'
    import Usuarios from '@/views/Modais/Ocorrencia/Tabs/Usuarios.vue'

    import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
    import CKEditor from '@ckeditor/ckeditor5-vue';

    export default {
        emits: ["ReloadGrid", "AtualizaIdPessoa"],
        name: 'LigacaoCrud',
        components: {
            'vue-select': VueNextSelect,
            InputSearch,
            Modal,
            DataTable,
            ModalWarper,
            EnviarEmail,
            ContatoCrud,
            MapaCliente,
            RegistrosGrid,
            Microphone,
            Dados,
            Tarefas_Executar,
            Agendamento,
            Senhas,
            Proposta,
            PropostaEventos,
            Processo,
            Usuarios,
            ckeditor: CKEditor.component
        },
        props: {
            idOcorrencia: {
                type: Number,
                default: 0
            },
            idPessoa: {
                type: Number,
                default: 0
            },
            idInstituicao: {
                type: Number,
                default: 0
            },
            idModulo: {
                type: Number,
                default: 0
            },
            show: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                filtro_text: "",

                editor: ClassicEditor,
                cdModalInfo: 0,
                ligacao_texto_padrao: '',
                pessoa: {},
                dados: {},
                ultimaLigacao: {},

                headersTelefone: [
                    { class: '', name: 'btns', text: 'Números disponíveis', actions: true, }
                ],

                headersTodosContatos: [
                    { class: 'text-break', name: 'btns', text: 'Todos os contatos', actions: true, }
                ],

                filtro: [
                    { active: true },
                ],
                nmEmpresa: '',
                telefone: '',
                ramal: 0,

                linhaSaidaSelects: {},
                linhaSaidaOptions: [
                    {
                        "idLinhaSaida": 1,
                        "nmLinha": "Principal",
                        cdLinhaSaida: 1
                    },
                    {
                        "idLinhaSaida": 2,
                        "nmLinha": "Secundária",
                        cdLinhaSaida: 2
                    },
                    {
                        "idLinhaSaida": 3,
                        "nmLinha": "Secundária - 02",
                        cdLinhaSaida: 3
                    },
                ],

                isOpenModalConatoCrudEm: false,

                isOpenModalMapa: false,

                isOpenModalEnviarEmail: false,

                isOpenModalTicketInfo: false,

                refresh_grid: false,
                NotLoading: false,

                nrReloadGrid: 0,
                showErrorMessage: false,
                key_modal_crud: 0,
                filtroBusca: '',
                status: 0,
                cdLigacaoCrud: 0,
                contatoStart: 0,
                mapaStart: 0,
                dinamicTablePage: '',
                dinamicTableRegNoPage: '',
                emailStart: 0,
                ligar_crud: {
                    idLigacao: 0,
                    cdOrigem: 8,
                    idInstituicao: 0,
                    idPessoa: 0,
                    idModulo: 0,
                    nrRamal: 0,
                    nrUniqueId: '',
                    nrTelefoneLigacao: '',
                    flEfetiva: false,
                    flImportante: false,
                    dsAnotacao: '',
                    cdLinhaSaida: 0
                },
                tipos_ligacao_textos_padroes: [],
                mostraTransicao: false,
            }
        },
        methods: {
            ligar(idPessoa) {
                let $this = this;

                this.$emit("AtualizaIdPessoa", idPessoa);
                $this.mostraTransicao = false;
                $this.zerarInformacoesDiv();
                $this.reloadGrid();
            },
            mostraDiv() {
                this.mostraTransicao = true;
            },
            escondeDiv(event) {
                if (!event.currentTarget.contains(event.relatedTarget) && this.refresh_grid == false && this.NotLoading == false) {
                    this.mostraTransicao = false;
                    this.zerarInformacoesDiv();
                }
            },
            rediscar_numero() {
                this.ligar_crud.dsAnotacao = 'Não foi feito uma anotação, pois foi feito uma rediscagem.';
                this.adicionar(true);
            },
            getUrlTodosContatos() {
                let $this = this;
                return process.env.VUE_APP_ROOT_COMERCIAL_API + '/Pessoa/GetPessoaLigacao?idInstituicao=' + $this.idInstituicao + '&idOcorrencia=' + $this.idOcorrencia + '&importante=todos';
            },
            getLigacaoTextoPadrao() {
                let $this = this;
                axios
                    .get(
                        process.env.VUE_APP_ROOT_COMERCIAL_API + "/LigacaoTextoPadrao/Get",
                        { headers: $this.$api.getTokenComercial(), }
                    )
                    .then((response) => {
                        $this.tipos_ligacao_textos_padroes = response.data.data;
                    });
            },
            abreModalInfo(_cd) {
                this.cdModalInfo = _cd;
                this.isOpenModalTicketInfo = true;
            },
            gera_historico_comercial() {
                var data_pdf = {
                    path: 'Comercial\\Clientes', name: 'relCliHistoricoComercial.rpt', database: 'NPComercialDB',
                    listParam: 'idInstituicao',
                    valueParam: this.idInstituicao,
                };
                const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data_pdf), 'reports_gnp').toString();
                var hash = encodeURIComponent(encryptedData);
                window.open(window.location.origin + '/Visualizador_Reports?hash=' + hash, '_blank');
            },
            refresh_anotacao(msg) {
                this.ligar_crud.dsAnotacao = msg;
            },
            updateSizeDinamic() {
                if (window.innerWidth <= 1400) {
                    this.dinamicTableRegNoPage = 'max-height: calc(100vh - 16rem);min-height: calc(100vh - 16rem);'
                } else {
                    this.dinamicTableRegNoPage = 'max-height: calc(100vh - 16rem);min-height: calc(100vh - 16rem);'
                }
            },
            zerarInformacoes() {
                let $this = this;

                $this.ultimaLigacao = {};

                $this.nmEmpresa = '';

                $this.pessoa = {};

                $this.telefone = '';

                $this.ramal = 0;

                $this.ligar_crud = {
                    idLigacao: 0,
                    cdOrigem: 8,
                    idInstituicao: 0,
                    idPessoa: 0,
                    nrRamal: 0,
                    idModulo: 0,
                    nrUniqueId: '',
                    nrTelefoneLigacao: '',
                    flEfetiva: false,
                    flImportante: false,
                    dsAnotacao: '',
                    cdLinhaSaida: 1
                };
                this.zerarInformacoesDiv()

            },
            zerarInformacoesDiv() {
                let $this = this;

                $this.filtro_text = "";

            },
            fecharModal() {
                this.zerarInformacoes();
                this.$emit('ReloadGrid');
            },
            fecharModalInfo() {
                this.isOpenModalTicketInfo = false;
            },
            gridRefreshed(data_ajax) {
                let $this = this;

                $this.refresh_grid = false;
            },
            reloadGrid() {
                let $this = this;

                $this.refresh_grid = true;
            },
            getDadosOcorrencia() {
                let $this = this;


                if ($this.idOcorrencia > 0) {
                    axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Ocorrencia/GetDadosOcorrencia?idOcorrencia=' + $this.idOcorrencia, {
                        headers: $this.$api.getTokenComercial(),
                        params: ''
                    }).then(response => {
                        $this.dados = response.data.data;
                        $this.nmEmpresa = '#' + $this.dados.cdInstituicao + ' ' + $this.dados.nmRazaoSocial;
                    })
                        .catch(function (error) {
                            var msg = 'Ocorreu um erro inesperado';
                            if (error.response) {
                                if (error.response.data.erros != '') {
                                    msg = error.response.data.errors[0];
                                } else {
                                    msg = error.response.data.msg;
                                }
                            }
                            $this.$toast.show('alert', msg, true);
                        });
                }

            },
            getUltimaLigacao() {
                let $this = this;

                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Ligacao/get?idOcorrencia=' + $this.idOcorrencia + '&idInstituicao=' + ($this.idInstituicao > 0 ? $this.idInstituicao : 0) + '&idPessoa=' + $this.idPessoa, {
                    headers: $this.$api.getTokenComercial(),
                    params: ''
                }).then(response => {
                    if (response?.data?.data?.rows?.length !== 0) {
                        $this.ultimaLigacao = response.data.data.rows[0];
                    } else {
                        $this.ultimaLigacao = {
                            dtInclusao: 'Sem Ligações',
                            dsLogin: 'Sem Ligações'
                        }
                    }
                }).catch(error => {
                    $this.ultimaLigacao = {
                        dtInclusao: 'Sem Ligações',
                        dsLogin: 'Sem Ligações'
                    }
                });
            },
            getPessoa() {
                let $this = this;

                if (($this.idPessoa > 0 && $this.idPessoa != null)) {
                    axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Pessoa/GetId?idPessoa=' + $this.idPessoa + '&idInstituicao=' + ($this.idInstituicao > 0 ? $this.idInstituicao : 0), {
                        headers: $this.$api.getTokenComercial(),
                        params: ''
                    }).then(response => {
                        $this.pessoa = response.data.data;
                    })
                        .catch(function (error) {
                            var msg = 'Ocorreu um erro inesperado';
                            if (error.response) {
                                if (error.response.data.erros != '') {
                                    msg = error.response.data.errors[0];
                                } else {
                                    msg = error.response.data.msg;
                                }
                            }

                            $this.$toast.show('alert', msg, true);
                        });
                }

            },
            selecionarTelefone(valueTelefone) {
                let $this = this;

                $this.telefone = valueTelefone;
            },
            getPessoaEmail() {
                let $this = this;

                return process.env.VUE_APP_ROOT_COMERCIAL_API + '/PessoaEmail/Get?idPessoa=' + $this.idPessoa;
            },
            getPessoaTelefone() {
                let $this = this;

                return process.env.VUE_APP_ROOT_COMERCIAL_API + '/PessoaTelefone/Get?idPessoa=' + $this.idPessoa;
            },
            func_crud(idPessoa, tpAlteracao) {

                if (tpAlteracao == 'Alterar') {
                    this.key_modal_crud += 1;
                    this.contatoStart = 1;
                    this.isOpenModalConatoCrudEm = true;
                } else if (tpAlteracao == 'Mapa') {
                    this.mapaStart = 1;
                    this.isOpenModalMapa = true;
                } else if (tpAlteracao == 'Pdf') {
                    axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Pessoa/GerarPDF?idPessoa=' + idPessoa, {
                        headers: this.$api.getTokenComercial(),
                        params: ''
                    }).then(response => {
                        window.open(response.data.data, "_blank");
                    });
                }
            },
            ligacao(value) {
                let $this = this;

                $this.ligar_crud = {
                    idLigacao: 0,
                    cdOrigem: 8,
                    idInstituicao: $this.idInstituicao,
                    idPessoa: $this.idPessoa,
                    idModulo: $this.idModulo,
                    idOcorrencia: $this.idOcorrencia,
                    nrRamal: $this.ramal,
                    nrUniqueId: '',
                    nrTelefoneLigacao: $this.telefone,
                    flEfetiva: false,
                    flImportante: false,
                    dsAnotacao: '',
                    cdLinhaSaida: $this.cdLigacaoCrud
                }
                $this.status = 1;

                $this.adicionar(false);
            },
            adicionar(rediscar) {
                let $this = this;

                var bck_telefone = this.telefone;

                $this.ligar_crud.idEvento = $this.dados.idEvento;

                axios.post(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Ligacao/Post', $this.ligar_crud, { headers: $this.$api.getTokenComercial() })
                    .then(function (response) {
                        $this.gridRefreshed();

                        if ($this.ligar_crud.idLigacao != response.data.data.idLigacao) {
                            $this.status = 0;
                            $this.ligar_crud = {
                                idLigacao: response.data.data.idLigacao,
                                cdOrigem: 8,
                                idInstituicao: response.data.data.idInstituicao,
                                idPessoa: response.data.data.idPessoa,
                                idModulo: response.data.data.idModulo,
                                idOcorrencia: response.data.data.idOcorrencia,
                                nrRamal: response.data.data.ramal,
                                nrUniqueId: response.data.data.nrUniqueId,
                                nrTelefoneLigacao: response.data.data.nrTelefoneLigacao,
                                flEfetiva: response.data.data.flEfetiva,
                                flImportante: response.data.data.flImportante,
                                dsAnotacao: '',
                                cdLinhaSaida: response.data.data.cdLinhaSaida
                            }
                        } else {
                            $this.status = 0;
                            $this.ligar_crud = {
                                idLigacao: 0,
                                cdOrigem: 8,
                                idInstituicao: 0,
                                idPessoa: 0,
                                nrRamal: 0,
                                idModulo: 0,
                                nrUniqueId: '',
                                nrTelefoneLigacao: '',
                                flEfetiva: false,
                                flImportante: false,
                                dsAnotacao: '',
                                cdLinhaSaida: 0
                            }
                            $this.telefone = '';
                        }
                        $this.getUltimaLigacao();
                        $this.nrReloadGrid += 1;

                        if (rediscar) {
                            $this.telefone = bck_telefone;
                            $this.ligacao($this.telefone);
                        }
                    })
                    .catch(function (error) {
                        var msg = '';
                        if (error.response) {
                            if (error.response.data.erros != '') {
                                msg = error.response.data.errors[0];
                            } else {
                                msg = error.response.data.msg;
                            }
                        }

                        $this.status = 0;
                        $this.$toast.show('alert', msg, true);
                    });
            },
            enviarEmail() {
                let $this = this;

                $this.emailStart = 1;
                $this.isOpenModalEnviarEmail = true;
            },
            setHistorico(result) {
                return result;
            }
        },
        mounted() {
            this.getLigacaoTextoPadrao();
            this.getDadosOcorrencia();
            this.getPessoa();
            this.getUltimaLigacao();
            this.reloadGrid();
            this.nrReloadGrid += 1;

            this.linhaSaidaSelects = this.linhaSaidaOptions.find((option) => {
                return option.cdLinhaSaida === 1;
            });

            this.updateSizeDinamic();
            window.addEventListener('resize', this.updateSizeDinamic);
        },
        updated() {
            this.updateSizeDinamic();
        },
        watch: {
            show(new_value, old_value) {
                this.ligacao_texto_padrao = '';
                this.getDadosOcorrencia();
                this.getPessoa();
                this.getUltimaLigacao();
                this.reloadGrid();
                this.nrReloadGrid += 1;
            },
            idPessoa(new_value, old_value) { },
            linhaSaidaSelects(new_value, old_value) {
                if (new_value) {
                    this.cdLigacaoCrud = new_value.cdLinhaSaida
                }
            },
            ligacao_texto_padrao(newVal, oldVal) {
                this.ligar_crud.dsAnotacao = newVal;
            },
            filtro_text: function (newVal, oldVal) {
                let $this = this;
                $this.filtro[0].value = newVal;
            },
        }
    }

</script>

<style scoped>

    button {
        font-size: 13px;
    }

    .fundo-dados {
        font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
    }

    .modal-body {
        min-height: 150px !important;
    }

    .fundo-panel {
        max-height: 77vh;
        overflow: auto;
    }

    h3 {
        color: #434343;
        font-size: 12px;
        font-family: Inter;
        font-weight: 700;
        text-align: left;
        margin-bottom: 0;
    }

    .tem_registro {
        color: #ACACAC;
        font-size: 14px;
        font-family: Inter;
        line-height: 140.625%;
        margin: 0 8px;
        border-radius: 5px;
        background: #FFF;
        height: 80px;
        padding: 8px;
        min-height: calc(100vh - 330px);
    }

    .card_registro {
        border-radius: 5px;
        background: #FFF;
        box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.25);
        padding: 8px;
    }

    .campo {
        padding-top: 8px;
    }

    .solid_bar {
        width: 4px;
        margin-right: 8px;
        border-radius: 2px;
        background: #9F3029;
    }

    .card_contato {
        border-radius: 5px;
        background: #FFF;
        box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.25);
        padding: 8px;
        text-align: center;
        position: relative;
    }

    strong {
        color: #434343;
        font-family: Inter;
        font-size: 12px;
        font-style: normal;
        font-weight: 700;
        height: 26px;
    }

    .card_text {
        color: #434343;
        font-family: Inter;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 140.625%;
        /* 16.875px */
    }

    .btn-editar-lista {
        border-radius: 5px;
        border: 1px solid #9F3029;
        background: #FFF;
        color: #9F3029;
        font-family: Inter;
        font-style: normal;
        font-weight: 700;
        line-height: 140.625%;
        padding: 8px 16px;
    }

    .content-modal-info {
        padding: 10px;
        overflow-y: auto;
        overflow-x: hidden;
        max-height: calc(100vh - 8rem);
        height: calc(100vh - 8rem);
        border-top: transparent !important;
    }

    .star-avaliacao {
        color: #9F3029;
        font-size: 11px;
    }

    .box-overlay {
        position: absolute;
        top: 0;
        right: 0;
        width: 50%;
        height: 100%;
        background-color: #fff;
        z-index: 1000;
        padding: 10px;
        pointer-events: auto;
    }

    /*.box-overlay div {
            pointer-events: none;
        }

        .box-overlay label {
            pointer-events: none;
        }*/

    .slide-enter-from {
        transform: translateX(100%);
        opacity: 0;
    }

    .slide-enter-active {
        transition: transform 0.5s ease, opacity 0.5s ease;
    }

    .slide-enter-to {
        transform: translateX(0);
        opacity: 1;
    }

    .slide-leave-from {
        transform: translateX(0);
        opacity: 1;
    }

    .slide-leave-active {
        transition: transform 0.5s ease, opacity 0.5s ease;
    }

    .slide-leave-to {
        transform: translateX(100%);
        opacity: 0;
    }

    .btn-div {
        position: relative;
        right: -11px;
    }

    .btn-order {
        box-sizing: border-box;
        width: 50px;
        height: 40px;
        background: #FFFFFF;
        box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.25);
        border-radius: 5px;
        margin-top: -2px;
    }

    .data {
        float: left;
    }

    .data-dados {
        padding-left: 12px;
        padding-right: 6px;
    }

    .btn-grid-excluir-lista {
        padding: 7px 10px !important;
        max-width: 43%;
    }

    @media screen and (max-width: 1400px) {
        .btn-Ligar {
            max-width: 63.5%;
        }

        .btn-grid-excluir-lista {
            max-width: 76px !important;
            margin: 0 10px 0 10px !important;
        }

        .span-add {
            display: none;
        }
    }
</style>